import { useContext, createContext } from "react";
export var useTreeContext = function () {
    var context = useContext(TreeContext);
    if (context === undefined) {
        throw new Error("A component has been used outside of the Provider components");
    }
    return context;
};
export var TreeContext = createContext(undefined);
